/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

import {getScrollableStyle} from '../../style';

const PREFIX = 'SubMenu';

const classes = {
  contentLock: `${PREFIX}-contentLock`,
  subMenu: `${PREFIX}-subMenu`,
  scrollable: `${PREFIX}-scrollable`,
  headerBox: `${PREFIX}-headerBox`,
  headerBackButton: `${PREFIX}-headerBackButton`,
  headerTitleBox: `${PREFIX}-headerTitleBox`,
  regularText: `${PREFIX}-regularText`,
  descriptionBox: `${PREFIX}-descriptionBox`,
};

interface RootProps {
  top: string;
  openSubMenu: boolean;
}

const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'top' && prop !== 'openSubMenu',
})<RootProps>(({theme, openSubMenu, top}) => ({
  '@keyframes fade': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 0.5,
    },
  },

  [`& .${classes.contentLock}`]: {
    position: 'absolute',
    left: '0',
    top,
    width: '300px',
    height: '100%',
    zIndex: 0,
    opacity: 0,
    background: '#000',
    animationName: 'fade',
    animationPlayState: 'running',
    animationIterationCount: '1',
    animationFillMode: 'forwards',
    animationDuration: '0.4s',
  },

  [`& .${classes.subMenu}`]: {
    width: '300px',
    height: '100%',
    position: 'absolute',
    top,
    left: openSubMenu ? 0 : '300px',
    zIndex: 1,
    backgroundColor: theme.palette.figma_gray_light_4?.main,
    transition: 'opacity 0.4s, left 0.4s',
    opacity: openSubMenu ? 1 : 0,
    borderRadius: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 0, 1, 0),
  },

  [`& .${classes.scrollable}`]: {
    ...getScrollableStyle(theme),
    height: '100%',
    overflowY: 'auto',
  },

  [`& .${classes.headerBox}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
    padding: theme.spacing(0, 4, 1, 0),
    borderBottom: '1px solid #e2e3e9',
    marginBottom: theme.spacing(1),
  },

  [`& .${classes.headerBackButton}`]: {
    border: 'none',
    background: 'none',
    width: '40px',
    height: '40px',
    borderRadius: 0,

    '&:hover': {
      background: '#daebfb',
    },
  },

  [`& .${classes.headerTitleBox}`]: {
    margin: theme.spacing(3, 0, 2, 0),
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.regularText}`]: {
    color: theme.palette.figma_gray_dark_5?.main,
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.12px',
  },

  [`& .${classes.descriptionBox}`]: {
    borderBottom: '1px solid #e2e3e9',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2, 4, 2, 4),
  },
}));

export {Root as SubMenuRoot, classes as subMenuClasses};
